// "Fields" and "Images" rail panels.

import React from "react";
import FeatherIcon from "feather-icons-react";
import FieldPicker from "../FieldPicker";
import { IconButton } from "../controls";

export function FieldsPanel({ fieldGroups, onPick, selectedIsText }) {
  return (
    <div className="td-panel">
      <p className="td-hint">
        {selectedIsText
          ? "Click a field to add it to the selected text, or drag it into any text box."
          : "Click a field to add it as new text, or drag it into any text box. Line-item fields are table columns."}
      </p>
      <FieldPicker groups={fieldGroups} onPick={onPick} draggable />
    </div>
  );
}

export function AssetsPanel({ assets, assetUrls, onUpload, onRemove, onAddToPage, onUseAsBackground, uploading }) {
  return (
    <div className="td-panel">
      <label className={`td-dropzone${uploading ? " is-busy" : ""}`}>
        <FeatherIcon icon={uploading ? "loader" : "upload-cloud"} size={22} />
        <span>{uploading ? "Uploading…" : "Upload a PNG, JPEG or WebP (up to 5 MB)"}</span>
        <input
          type="file"
          accept="image/png,image/jpeg,image/webp"
          disabled={uploading}
          onChange={(e) => {
            const file = e.target.files?.[0];
            e.target.value = "";
            if (file) onUpload(file);
          }}
        />
      </label>
      <p className="td-hint">
        "My logo" elements use the logo on your vendor profile. Upload here for any other image — a stamp, signature or
        a different logo.
      </p>
      <ul className="td-assets">
        {assets.map((a) => (
          <li key={a.id} className="td-asset">
            <div className="td-asset__thumb">
              {assetUrls[a.id] ? <img src={assetUrls[a.id]} alt="" /> : <FeatherIcon icon="image" size={20} />}
            </div>
            <div className="td-asset__meta">
              <div className="td-asset__name" title={a.filename}>{a.filename || a.id}</div>
              {a.width && a.height ? <div className="td-hint">{a.width} × {a.height}px</div> : null}
            </div>
            <div className="td-asset__tools">
              <IconButton icon="plus-square" label="Add to page" onClick={() => onAddToPage(a)} />
              <IconButton icon="layers" label="Use as page background" onClick={() => onUseAsBackground(a)} />
              <IconButton icon="trash-2" label="Remove image" danger onClick={() => onRemove(a)} />
            </div>
          </li>
        ))}
        {!assets.length && <li className="td-empty">No images uploaded yet.</li>}
      </ul>
    </div>
  );
}
